// extracted by mini-css-extract-plugin
export default {"wrapperWidgets":"paid-widgets_wrapperWidgets__wxNbW","paidWidgetsContainer":"paid-widgets_paidWidgetsContainer__BvqFH","controlBtn":"paid-widgets_controlBtn__ZxLks"};